/**
 * Module: `export/docx-disclaimer.ts` — color the Sources-tierces disclaimer
 * to match PDF (`EXPORT_COLOR_SECONDARY` ≈ theme `--secondary`).
 */

import { EXPORT_COLOR_SECONDARY } from "@/lib/export/export-styles";
import { RESPONSE_EXPORT_DISCLAIMER } from "@/lib/export/response-export-document";

const DISCLAIMER_MARKER = "Sources tierces à Sidoni";

/**
 * Colors bold runs that carry the export disclaimer (split across `w:t` ok).
 */
export function enhanceDocxDisclaimer(documentXml: string): string {
  return documentXml.replace(
    /<w:r\b([^>]*)>([\s\S]*?)<\/w:r>/g,
    (run, attrs, inner) => {
      const isBold = /<w:b\b/.test(inner) || /<w:b\s*\/>/.test(inner);
      if (!isBold) return run;

      const text = Array.from(
        String(inner).matchAll(/<w:t\b[^>]*>([\s\S]*?)<\/w:t>/g)
      )
        .map((match) => match[1] ?? "")
        .join("");
      const normalized = text.replace(/\s+/g, " ").trim();
      const isDisclaimer =
        normalized === RESPONSE_EXPORT_DISCLAIMER ||
        normalized.includes(DISCLAIMER_MARKER);
      if (!isDisclaimer) return run;

      if (
        new RegExp(`<w:color\\b[^>]*w:val="${EXPORT_COLOR_SECONDARY}"`).test(
          inner
        )
      ) {
        return run;
      }

      if (/<w:rPr>/.test(inner)) {
        const nextInner = inner.replace(
          /<w:rPr>([\s\S]*?)<\/w:rPr>/,
          (_m, rprInner) => {
            let patched = String(rprInner).replace(/<w:color\b[^/]*\/>/g, "");
            patched += `<w:color w:val="${EXPORT_COLOR_SECONDARY}"/>`;
            return `<w:rPr>${patched}</w:rPr>`;
          }
        );
        return `<w:r${attrs}>${nextInner}</w:r>`;
      }

      return `<w:r${attrs}><w:rPr><w:b/><w:color w:val="${EXPORT_COLOR_SECONDARY}"/></w:rPr>${inner}</w:r>`;
    }
  );
}
